import type { useTranslations } from 'next-intl'
import { DEFAULT_LOCALE } from '@/i18n/config'

/**
 * omnyqra: UI language (Omnyqra/sim#43), see FORK.md.
 *
 * `quickValidateEmail` (lib/messaging/email/validation.ts, upstream) returns its
 * reason as an English sentence. This maps the known reasons to message keys. A
 * reason upstream adds or rewords is shown as is in English, as upstream does, and
 * as the generic message in other languages.
 */
type EmailReasonKey =
  | 'emailInvalidFormat'
  | 'emailMissingDomain'
  | 'emailDisposable'
  | 'emailSuspicious'
  | 'emailInvalidDomain'

const REASON_KEYS: ReadonlyMap<string, EmailReasonKey> = new Map([
  ['Invalid email format', 'emailInvalidFormat'],
  ['Missing domain', 'emailMissingDomain'],
  ['Disposable email addresses are not allowed', 'emailDisposable'],
  ['Email contains suspicious patterns', 'emailSuspicious'],
  ['Invalid domain format', 'emailInvalidDomain'],
])

export type AuthValidationTranslator = ReturnType<typeof useTranslations<'auth.validation'>>

export function emailValidationMessage(
  reason: string | undefined,
  t: AuthValidationTranslator,
  locale: string
): string {
  const key = reason ? REASON_KEYS.get(reason) : undefined
  if (key) return t(key)
  return reason && locale === DEFAULT_LOCALE ? reason : t('emailInvalid')
}
